export enum EquipmentType {
  Regular = 'regular',
  Flatbed =  'flatbed',
  Dropdeck =  'dropdeck',
  Refrigerated =  'refrigerated'
};

export const equipmentTypeOptions: Array<{value: string, name: string}> = [
  { value: EquipmentType.Regular, name: 'Regular' },
  { value: EquipmentType.Flatbed, name: 'Flatbed' },
  { value: EquipmentType.Dropdeck, name: 'Dropdeck' },
  { value: EquipmentType.Refrigerated, name: 'Refrigerated' }
];

export enum SpecialType {
  Dangerous_Goods = 'dangerous goods',
  Perishables = 'perishables',
  Valuables =  'valuables',
  Vulnerables =  'vulnerables',
  Pharmaceuticals =  'pharmaceuticals'
};

export const specialTypeOptions: Array<{value: string, name: string}> = [
  { value: SpecialType.Dangerous_Goods, name: 'Dangerous Goods' },
  { value: SpecialType.Perishables, name: 'Perishables' },
  { value: SpecialType.Valuables, name: 'Valuables' },
  { value: SpecialType.Vulnerables, name: 'Vulnerables' },
  { value: SpecialType.Pharmaceuticals, name: 'Pharmaceuticals' }
];

export enum STAType {
  Hazmat_CDL = 'Hazmat CDL',
  Tsa_Issued = 'TSA Issued STA',
  Airport =  'Airport ID',
};

export const STATypeOptions: Array<{value: string, name: string}> = [
  { value: STAType.Hazmat_CDL, name: 'Hazmat CDL' },
  { value: STAType.Tsa_Issued, name: 'TSA Issued STA' },
  { value: STAType.Airport, name: 'Airport ID' }
];